import { DELETE_SHOPPING_LIST_ITEM } from "../../app/graphql/mutations";
import { useMutation } from "@apollo/client";

const useUpdateGroceryListFromRemovingIngredient = () => {
    const [deleteGroceryListItem, { loading }] = useMutation(DELETE_SHOPPING_LIST_ITEM);

    const updateGroceryListFromRemovingIngredient = async ({ ingredientId }: { ingredientId: string }) => {
        try {
            await deleteGroceryListItem({
                variables: {
                    where: {
                        ingredient_id: { _eq: ingredientId }
                    }
                },
            });
        } catch (err) {
            console.error("Error deleting ingredient from shopping list item:", err);
        }
    }
    return {
        updatingGroceryListFromRemovingIngredient: loading,
        updateGroceryListFromRemovingIngredient,
    }
}

export default useUpdateGroceryListFromRemovingIngredient